var ModulesExitIntent = {
	Module: require('./modules/Module'),
	ExitIntent: require('./modules/ModuleExitIntent'),
	Modal: require('./modules/ModuleModal'),
};

window.Modules = { ...window.Modules, ...ModulesExitIntent };
